module.exports = __webpack_public_path__ + "img/sg.966947b5.svg";